export const cibPalantir = ["32 32","<path d='M26.865 24l-10.865 4.24-10.865-4.24-1.802 3.125 12.667 4.875 12.667-4.875zM16 0c-6.995 0-12.667 5.672-12.667 12.667s5.672 12.667 12.667 12.667c6.995 0 12.667-5.672 12.667-12.667s-5.672-12.667-12.667-12.667zM16 21.438c-4.839 0-8.755-3.922-8.755-8.755 0-4.839 3.917-8.76 8.755-8.76s8.755 3.922 8.755 8.76c0 4.833-3.917 8.755-8.755 8.755z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-palantir.js
// module id = null
// module chunks = 